module.exports = __webpack_public_path__ + "img/Phone_07.e8c07327.jpg";